import React, { useEffect, useState } from "react"
import { Button } from "reactstrap"
import { get } from "helpers/api_helper"
import { settingsTime } from "./maintenanceForm"

export default function MaintenanceObservation({ refresh, revision }) {
  const [retry, setRetry] = useState(0), [read, setRead] = useState({ loading: true })
  useEffect(() => {
    let current = true
    setRead({ loading: true })
    const verify = async () => {
      const response = await get("/settings-maintenance/web-proof", { timeout: 5000 })
      const target = new URL(response?.data?.url)
      const configured = new URL(process.env.REACT_APP_WEB_URL)
      if (!["http:", "https:"].includes(target.protocol) || target.origin !== configured.origin || target.username || target.password
        || target.pathname !== "/_operations/website-maintenance" || target.search || target.hash
        || typeof response.data.proof !== "string" || !response.data.proof || response.data.proof.length > 2048) throw new Error("Unverified Web target")
      if (!current) return
      // Only the short-lived, purpose-bound proof crosses this verified Web origin. Never the CP cookie.
      const observed = await get(target.href, { withCredentials: false, credentials: "omit", timeout: 5000, headers: { Authorization: `Bearer ${response.data.proof}` } })
      const data = observed?.data
      if (typeof data?.on !== "boolean" || typeof data.serverOverride !== "boolean" || data.scope !== "responding-web-instance"
        || !["server", "unknown", "last-confirmed", "stored-setting"].includes(data.source) || !Number.isFinite(Date.parse(data.observedAt))) throw new Error("Invalid observation")
      if (current) setRead({ data })
    }
    verify().catch(() => { if (current) setRead({ error: true }) })
    return () => { current = false }
  }, [refresh, retry])
  return <section className="system-settings__observation" aria-label="Observed website status">
    <div className="system-settings__heading"><h5>Website status</h5><Button size="sm" disabled={read.loading} onClick={() => setRetry(value => value + 1)}>Check website status</Button></div>
    {read.loading && <p role="status">Checking website status…</p>}
    {read.error && <p role="status">Website status unavailable. The saved setting remains separate; the server override could not be verified.</p>}
    {read.data && <>
      <p><strong>Observed website state: {read.data.on ? "On" : "Off"}</strong></p>
      {read.data.serverOverride && <p className="text-warning">Server emergency override is active. Saving Off in CPanel will not turn it off.</p>}
      {read.data.source === "unknown" && <p>The website is showing maintenance until its first valid settings check succeeds.</p>}
      {read.data.source === "last-confirmed" && <p>Settings verification is temporarily unavailable. The website is using its last confirmed state.</p>}
      {Number.isSafeInteger(revision) && read.data.revision !== revision && <p>The observed instance has not confirmed the current saved revision. Check its status again.</p>}
      <p className="text-muted mb-0">Checked: {settingsTime(read.data.observedAt)}. This observation covers the responding Web instance; other instances may differ.</p>
    </>}
  </section>
}
